import type React from 'react'
import styled from 'styled-components'

import type { Outcome } from '@/lib/apollo/model/outcome'
import { OverallOutcomeStatus } from '@/lib/apollo/model/outcome'
import type { Application } from '@/types/Activity'
import { Colours } from '@/utils/styles'

import Card from './Card'

const Container = styled(Card)<{ $isCancelled?: boolean }>`
  text-align: center;
  background: ${props => (props.$isCancelled ? Colours.red : 'white')};
  color: ${props => (props.$isCancelled ? Colours.white : 'inherit')};
`

interface Props {
  application: Application
}

const getOutcomeLabel = (outcome?: Outcome) => {
  if (!outcome || !outcome.status) {
    return <h2>Application data is being collected</h2>
  }

  const { status, comments } = outcome
  switch (status) {
    case OverallOutcomeStatus.rejected:
      return <h2>Application has been rejected</h2>
    case OverallOutcomeStatus.fail:
    case OverallOutcomeStatus.awaitingReview:
      return <h2>Application requires manual review</h2>
    case OverallOutcomeStatus.reOpened:
      return <h2>Application was reopened</h2>
    case OverallOutcomeStatus.pass:
    case OverallOutcomeStatus.accepted:
      return <h2>Application has been accepted</h2>
    case OverallOutcomeStatus.cancelled:
      return <h2>Applicant is inactive</h2>
    case OverallOutcomeStatus.passReview:
      return (
        <>
          <h2>Application needs your attention</h2>
          {comments && <p>{comments}</p>}
        </>
      )
  }
  return <h2>Application data is being collected</h2>
}

const OverallOutcomeCard: React.FC<Props> = ({ application }) => (
  <Container
    $isCancelled={application.outcome?.status === OverallOutcomeStatus.cancelled}
  >
    {getOutcomeLabel(application.outcome)}
  </Container>
)

export default OverallOutcomeCard
